import { DonutData } from '@/features/TimeStatsModel';

import s from './CustomTooltip.module.scss';

type TooltipProps = {
  active?: boolean;
  payload?: any;
};

const CustomTooltip: React.FC<TooltipProps> = ({ active, payload }) => {
  if (!active || !payload?.length) return null;

  const item = payload[0].payload as DonutData;
  const color = payload[0].payload.fill;

  return (
    <div className={s.custom_tooltip}>
      <p className={s.custom_tooltip__title} style={{ color }}>
        {item.name}
      </p>
      <p className={s.custom_tooltip__time}>
        {item.label} ({item.percent})
      </p>
    </div>
  );
};

export { CustomTooltip };
